import { useGetProfileQuery } from "@/api/AppApi/services/auth";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { LoginMethodTypes } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useAtom } from "jotai";
import { isSignedInAtom } from "./authAtoms";

export enum VerifiyTypes {
  mobile = 1,
  email = 2,
}
export const useNeedAccountVerify = () => {
  const [isSignedIn] = useAtom(isSignedInAtom);
  const getCompany = useGetCompanyQuery();
  const getProfile = useGetProfileQuery();
  if (!isSignedIn || getProfile.isLoading) return false;
  const customer_login_methods =
    getCompany.data?.result?.theme?.settings?.customer_login_methods;
  const { is_mobile_verified, is_email_verified, mobile_fields, email } =
    getProfile.data?.result ?? {};
  if (is_mobile_verified && is_email_verified) return false;
  switch (customer_login_methods) {
    case LoginMethodTypes.both:
      if (!is_mobile_verified) return VerifiyTypes.mobile;
      if (!is_email_verified) return VerifiyTypes.email;
    case LoginMethodTypes.any:
      if (mobile_fields?.number && !is_mobile_verified)
        return VerifiyTypes.mobile;
      if (email && !is_email_verified) return VerifiyTypes.email;
      return false;
    case LoginMethodTypes.by_phone:
      if (!is_mobile_verified) return VerifiyTypes.mobile;
      return false;
    case LoginMethodTypes.by_email:
      if (!is_email_verified) return VerifiyTypes.email;
    default:
      return false;
  }
};
